export const MAX_MODEL_NUM = 4;

export const CHECKBOX_OPTIONS = [
  {
    name: "option1",
    label: "리드타임",
    icon: "AccessTime",
  },
  {
    name: "option2",
    label: "전체일정",
    icon: "CalendarToday",
  },
  {
    name: "option3",
    label: "납기 준수",
    icon: "EventAvailable",
    // forwardOnly: true,
  },
  {
    name: "option4",
    label: "주문 우선순위",
    icon: "Build",
  },
];

export const COLORS = {
  forward: {
    background: "#edf6fc",
    selected: "#1976d2",
    hover: "#e3f2fd",
  },
  backward: {
    background: "#f7eded",
    selected: "#ff8787",
    hover: "#ffe8e8",
  },
  "Back + Forward": {
    background: "#7dfa87",
    selected: "#bec2be",
    hover: "#0ac919",
  },
};
